import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class InvoiceTypes {
  static loadInvoice: IActionType = new ActionType('INVOICE/LOAD_INVOICE');
  static listInvoiceStatus: IActionType = new ActionType('INVOICE/LIST_INVOICE_STATUS');
  static refundInvoice: IActionType = new ActionType('INVOICE/REFUND_INVOICE');
  static listInvoiceItems: IActionType = new ActionType('INVOICE/LIST_INVOICE_ITEMS');
  static loadInvoiceHistory: IActionType = new ActionType('INVOICE/LOAD_INVOICE_HISTORY');
  static addAffiliateInvoice: IActionType = new ActionType('INVOICE/ADD_AFFILIATE_INVOICE');
  static loadProductAccess: IActionType = new ActionType('INVOICE/LOAD_PRODUCT_ACCESS');
  static loadProductHistoryAccess: IActionType = new ActionType('INVOICE/LOAD_PRODUCT_HISTORY_ACCESS');
  static sendBoleto: IActionType = new ActionType('INVOICE/SEND_BOLETO_INVOICE');
  static delivery: IActionType = new ActionType('INVOICE/DELIVERY_INVOICE');
  static loadListPins: IActionType = new ActionType('INVOICE/LIST_PINS_INVOICE');
  static partialRefundInvoice: IActionType = new ActionType('INVOICE/PARTIAL_REFUND_INVOICE');
  static downloadRefundReceipt: IActionType = new ActionType('INVOICE/DOWNLOAD_REFUND_RECEIPT');
}

export default InvoiceTypes;
